/* unplugin-vue-components disabled */import __unplugin_components_9 from '~icons/mdi/chevron-left';
import __unplugin_components_8 from '~icons/mdi/chevron-right';
import __unplugin_components_7 from '~icons/mdi/email';
import __unplugin_components_6 from '~icons/mdi/phone-classic';
import __unplugin_components_5 from '~icons/mdi/whatsapp';
import __unplugin_components_4 from '~icons/mdi/dots-vertical';
import __unplugin_components_3 from '~icons/mdi/email';
import __unplugin_components_2 from '~icons/mdi/phone-classic';
import __unplugin_components_1 from '~icons/mdi/whatsapp';
import __unplugin_components_0 from '~icons/mdi/menu';
var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "v-app-bar",
        {
          attrs: {
            app: "",
            dense: !_vm.isMobile,
            color: _vm.theme.primary,
            dark: "",
            "clipped-left": "",
            fixed: "",
          },
        },
        [
          _c(
            "v-btn",
            {
              attrs: { icon: "", "aria-label": "Menu" },
              on: {
                click: function ($event) {
                  return _vm.$store.dispatch("app/toggleDrawer")
                },
              },
            },
            [_c(__unplugin_components_0)],
            1
          ),
          _vm._v(" "),
          _c(
            "span",
            { staticStyle: { "align-self": "flex-center" } },
            [
              _c(
                "v-btn",
                {
                  attrs: {
                    "aria-label": "site",
                    title: _vm.site.name,
                    icon: "",
                    href: "./",
                  },
                },
                [
                  _c("img", {
                    attrs: {
                      alt: _vm.site.name,
                      src: "src/fotos/configurations/" + _vm.site.logo,
                      height: _vm.isMobile ? "35px" : "25px",
                    },
                  }),
                ]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _vm.isMobile
            ? _c("v-app-bar-title", { staticClass: "ml-2" }, [
                _vm._v("\n      " + _vm._s(_vm.site.name) + "\n    "),
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("v-spacer"),
          _vm._v(" "),
          _vm.$vuetify.breakpoint.smAndUp
            ? _c(
                "div",
                { staticClass: "ml-2" },
                [
                  _vm._v("\n      Agendar consulta:\n      "),
                  _vm.site.whatsapp
                    ? _c(
                        "v-btn",
                        {
                          attrs: {
                            title: "Whasapp",
                            "aria-label": "whasapp",
                            icon: "",
                          },
                          on: { click: _vm.openWhats },
                        },
                        [_c(__unplugin_components_1)],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      attrs: {
                        title: "Telefone",
                        icon: "",
                        href: "tel:" + _vm.site.fone,
                      },
                    },
                    [_c(__unplugin_components_2)],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    { attrs: { title: "Contato", icon: "", href: "contato" } },
                    [_c(__unplugin_components_3)],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "v-menu",
            {
              attrs: {
                "offset-y": "",
                left: "",
                rounded: "0",
                "close-on-content-click": !1,
              },
              scopedSlots: _vm._u([
                {
                  key: "activator",
                  fn: function ({ on, attrs }) {
                    return [
                      _c(
                        "v-btn",
                        _vm._g(
                          _vm._b(
                            {
                              attrs: {
                                "aria-label": "outras opções",
                                dark: "",
                                icon: "",
                              },
                            },
                            "v-btn",
                            attrs,
                            false
                          ),
                          on
                        ),
                        [_c(__unplugin_components_4)],
                        1
                      ),
                    ]
                  },
                },
              ]),
            },
            [
              _vm._v(" "),
              _c(
                "v-list",
                { attrs: { dense: "" } },
                [
                  !_vm.$vuetify.breakpoint.smAndUp
                    ? _c("v-subheader", [_vm._v("Contate-nos")])
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.$vuetify.breakpoint.smAndUp
                    ? _c(
                        "v-list-item",
                        { on: { click: _vm.openWhats } },
                        [
                          _c("v-list-item-icon", [_c(__unplugin_components_5)], 1),
                          _vm._v(" "),
                          _c("v-list-item-title", [_vm._v("Whatsapp")]),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.$vuetify.breakpoint.smAndUp && !_vm.isMobile
                    ? _c(
                        "v-list-item",
                        { attrs: { href: "tel:" + _vm.site.fone } },
                        [
                          _c(
                            "v-list-item-icon",
                            [_c(__unplugin_components_6)],
                            1
                          ),
                          _vm._v(" "),
                          _c("v-list-item-title", [_vm._v("Telefone")]),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.$vuetify.breakpoint.smAndUp
                    ? _c(
                        "v-list-item",
                        { attrs: { href: "contato", target: "_blank" } },
                        [
                          _c("v-list-item-icon", [_c(__unplugin_components_7)], 1),
                          _vm._v(" "),
                          _c("v-list-item-title", [_vm._v("Email")]),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.$vuetify.breakpoint.smAndUp ? _c("v-divider") : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "v-list-item",
                    {
                      staticClass: "isDark",
                      attrs: { dense: "" },
                      on: { click: _vm.toggleDark },
                    },
                    [
                      _c(
                        "v-list-item-title",
                        [
                          _c("v-switch", {
                            staticClass: "mt-3",
                            attrs: { dense: "", label: "Tema escuro" },
                            model: {
                              value: _vm.isDark,
                              callback: function ($$v) {
                                _vm.isDark = $$v
                              },
                              expression: "isDark",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _vm.isMobile
        ? _c(
            "v-navigation-drawer",
            {
              staticClass: "menu-site",
              attrs: {
                clipped: "",
                stateless: "",
                app: "",
                "mini-variant": _vm.drawerMini,
                "expand-on-hover": _vm.expand,
              },
              on: {
                "update:miniVariant": function ($event) {
                  _vm.drawerMini = $event
                },
                "update:mini-variant": function ($event) {
                  _vm.drawerMini = $event
                },
              },
              model: {
                value: _vm.drawer,
                callback: function ($$v) {
                  _vm.drawer = $$v
                },
                expression: "drawer",
              },
            },
            [
              _c("layout-menu"),
              _vm._v(" "),
              _c(
                "v-footer",
                {
                  attrs: {
                    id: "mini",
                    color: _vm.theme.primary,
                    app: "",
                    dark: "",
                    inset: "",
                  },
                },
                [
                  !_vm.drawerMini ? _c("v-spacer") : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      attrs: { icon: "" },
                      on: {
                        click: function ($event) {
                          $event.stopPropagation()
                          return _vm.$store.dispatch("app/toggleDrawerMini")
                        },
                      },
                    },
                    [
                      _vm.drawerMini
                        ? _c(__unplugin_components_8, {
                            attrs: { title: "expandir" },
                          })
                        : _c(__unplugin_components_9, {
                            attrs: { title: "minimizar" },
                          }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _c(
            "v-navigation-drawer",
            {
              attrs: {
                bottom: "",
                fixed: "",
                dark: "",
                height: "auto",
                app: "",
                "hide-overlay": "",
                color: _vm.theme.primary,
              },
              model: {
                value: _vm.drawer,
                callback: function ($$v) {
                  _vm.drawer = $$v
                },
                expression: "drawer",
              },
            },
            [_c("layout-menu")],
            1
          ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }